// extracted by mini-css-extract-plugin
export default {"boxRule":"src-hellosign-common-layout-layout-module__boxRule--2l_Eg","responsive":"src-hellosign-common-layout-layout-module__responsive--2OU7y"};